<template>
  <div class="processParent">
    <h2>our process</h2>
    <div class="process">
      <div class="one">
        <p>Greet</p>
        <p class="pand">&</p>
        <p>Examine</p>
      </div>
      <img src="../assets/arrowr.svg" alt />
      <div class="two">
        <p>Concept</p>
        <p class="pand">&</p>
        <p>Prototype</p>
      </div>
      <img src="../assets/arrowr.svg" alt />
      <div class="three">
        <p>Develop</p>
        <p class="pand">&</p>
        <p>Deliver</p>
      </div>
    </div>
    <router-link class="button leanmore" to="/about">
      <p>tell me more</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "HowProcess"
};
</script>

<style scoped lang="scss">
div.processParent {
  margin: 2rem;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .leanmore {
    @include mediumScreen {
      align-self: flex-end;
    }
  }

  @include mediumScreen {
    align-items: start;
  }
  div.process {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;

    div {
      margin: 0 1rem;
      @include mediumScreen {
        margin: 0 1.5rem;
      }
    }

    img {
      width: 1em;
      height: 1em;
    }

    @include mediumScreen {
      margin: 2rem;
      margin-top: 0.5rem;
      justify-content: space-evenly;
    }
  }
}
</style>
